/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Static constants for all branding UI bundle property keys.
 * Used when looking up values from the cached branding response
 * or from fallback local JSON files.
 */
export class BrandingUiInfoKeys {
  public static readonly APP_ICONS = {
    DEFAULT_BACKGROUND: "defaultBackground",
    DEFAULT_EMPTY_STRIP: "defaultEmptyStrip",
    LIVE_ICON: "liveIcon",
    LIVE_ICON_SOURCE: "liveSourceIcon",
    NAV_GUIDE_HIGHLIGHTED_ICON: "navGuideHighlightedIcon",
    NAV_GUIDE_ICON: "navGuideIcon",
    NAV_MY_SHOWS_HIGHLIGHTED_ICON: "navMyShowsHighlightedIcon",
    NAV_MY_SHOWS_ICON: "navMyShowsIcon",
    NAV_SETTINGS_HIGHLIGHTED_ICON: "navSettingsHighlightedIcon",
    NAV_SETTINGS_ICON: "navSettingsIcon",
    NEW_ICON: "newIcon",
    PC_LOCKED_4x3: "pcLocked4x3Image",
    PC_LOCKED_16x9: "pcLocked16x9Image",
    PC_LOCKED_ICON: "pcLockedIcon",
    PC_PIN_SPINNER: "pcPinSpinner",
    PIN_CONTROL_ARROW_DOWN: "pinControlArrowDownIcon",
    PIN_CONTROL_ARROW_UP: "pinControlArrowUpIcon",
    SOURCE_SOCU_ICON: "SOURCE_SOCU_ICON",
    SECONDARY_BRANDING: "secondaryBranding",
    SCROLLING_PILL_LEFT_ARROW: "scrollingPillLeftArrow",
    SCROLLING_PILL_RIGHT_ARROW: "scrollingPillRightArrow",
    SCROLLING_PILL_GHOST_LEFT_ARROW: "scrollingPillGhostLeftArrow",
    SCROLLING_PILL_GHOST_RIGHT_ARROW: "scrollingPillGhostRightArrow",
    VIEW_ALL_LEFT_ARROW: "viewAllLeftArrow"
  };

  public static readonly APP_IMAGES: string = "appImages";
  public static readonly CATCH_UP: string = "catchupName";
  public static readonly CUSTOMER_SUPPORT_NAME: string = "customerSupportName";
  public static readonly DEVICE_NAME: string = "deviceName";
  public static readonly DEVICE_NAME_SHORT: string = "deviceNameShort";
  public static readonly DISPLAY_NAME: string = "displayName";
  public static readonly DISTRIBUTOR_NAME: string = "distributorName";
  public static readonly EAS_CONFIGURATION: string = "easConfiguration";
  public static readonly EAS_DISPLAY_MODE: string = "easDisplayMode";
  public static readonly EPG_LOOK_BACK_HOURS: string = "epgLookBackHours";
  public static readonly IMAGE: string = "image";
  public static readonly MANUFACTURER_NAME: string = "manufacturerName";
  public static readonly PHONE_CUSTOMER_SUPPORT_NUMBER: string =
    "phoneCustomerSupportNumber";
  public static readonly PHONE_UPSELL: string = "phoneUpsell";
  public static readonly START_OVER: string = "startoverName";
  public static readonly URL_CUSTOMER_SUPPORT: string = "urlCustomerSupport";
  public static readonly URL_ERROR: string = "urlError";
  public static readonly URL_PRIVACY: string = "urlPrivacy";
  public static readonly URL_UPSELL: string = "urlUpsell";
  public static readonly YOUR_CABLE_PROVIDER: string = "yourCableProvider";
  public static readonly IOS_APP_ID: string = "iosAppId";
  public static readonly ANDROID_APP_ID: string = "androidAppId";
  public static readonly APP_SCHEME: string = "appScheme";
  public static readonly MSO_NAME: string = "msoName";
}
